import { Box, Input, InputGroup, InputRightElement } from '@chakra-ui/react';
import { ClearButton } from 'components/atoms/ClearButton';
import { memo, FC } from 'react';

type Props = {
  value: string;
  handleChange: (value: string) => void;
};

export const SearchFields: FC<Props> = memo(
  ({ value, handleChange }: Props) => {
    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      handleChange(e.target.value);
    };

    const onClearClick = () => {
      handleChange('');
    };

    return (
      <Box w="100%">
        <InputGroup size="md">
          <Input
            w="100%"
            type="text"
            placeholder="検索"
            value={value}
            onChange={onChange}
          />
          <InputRightElement width="4.5rem">
            <ClearButton onClick={onClearClick} />
          </InputRightElement>
        </InputGroup>
      </Box>
    );
  },
);
